import React from 'react'

import {
  A,
  Div,
  P,
  Section,
  Strong 
} from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { openSidebar } from 'utils' 
import { isFreeUser } from 'utils/planAccess'

const contactLimitMessage = (
  <Section className="contact-import-instructions--group">
    <Icon height={40} width={40}
      name="contacts" />
    <Strong>Imported contacts count towards your limit</Strong>
    <P>You can get a higher contact limit in less than 2 min. <A href="/settings/billing" target="_blank">Upgrade here</A> or <span className="link-style" onClick={openSidebar}>chat with us!</span></P>
  </Section >
)

const ImportInstructions = () => (
  <Div className="contact-import-instructions">
    {isFreeUser() && contactLimitMessage}
    <Section className="contact-import-instructions--group">
      <Icon height={40} width={40}
        name="email-2-at" />
      <Strong>Every contact needs an email or userID</Strong>
      <P>We only import users who have an email or userID attached to them. <A href="http://help.drift.com/setup/csv-upload" rel="noopener noreferrer"
        target="_blank">Learn more
      </A>.
      </P>
    </Section>
    <Section className="contact-import-instructions--group">
      <Icon height={40} width={40}
        name="list-bullets" />
      <Strong>Drift won’t import duplicate contacts</Strong>
      <P>If we find the same email address already in Drift we won’t import them again, we will update their current info. <A href="http://help.drift.com/setup/csv-upload" rel="noopener noreferrer"
        target="_blank">Learn more                                                                                                                  </A>.
      </P>
    </Section>
    <Section className="contact-import-instructions--group">
      <Icon height={40} width={40}
        name="warning-triangle" />
      <Strong>View import errors after uploading</Strong>
      <P>If contacts are missing an email or userID, you can view the number of failed contacts and errors in the <A href="/contacts/imports">import table.</A></P>
    </Section>
  </Div>
)

export default ImportInstructions
